module.exports = __webpack_public_path__ + "static/img/icon44.3352bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon44.png
// module id = WPlM
// module chunks = 0